<ng-content select=".floori-input-prefix"></ng-content>

@if (type === 'textarea') {
<textarea
    #input
    [flooriDisableEnter]="disableSubmit"
    [placeholder]="placeholder"
    (focus)="focusChanged(true)"
    (blur)="focusChanged(false)"
    (input)="value = $any($event.target)?.value"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"></textarea>
} @else {
<input
    #input
    [flooriDisableEnter]="disableSubmit"
    [type]="resolvedInputType"
    [attr.inputmode]="type === 'number' ? 'decimal' : null"
    [placeholder]="placeholder"
    (focus)="focusChanged(true)"
    (blur)="focusChanged(false)"
    (input)="value = $any($event.target)?.value"
    (beforeinput)="handleBeforeInput($event)"
    (keydown)="handleKeydown($event)"
    [min]="minValue"
    [max]="maxValue"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"
    [step]="stepValue" />
} @if (clear && !disabled && !readonly) {
<div class="floori-input-clear" (click)="clearValue()">
    @if (value) {
    <button floori-icon-button tabindex="-1">
        <floori-icon name="fl_close"></floori-icon>
    </button>
    }
</div>
} @if (isPassword) {
<div class="floori-input-toggle-password">
    <button type="button" floori-icon-button (click)="changeVisibility()" tabindex="-1">
        @if (isPasswordVisible) {
        <floori-icon name="fl_eye_slash_o" [flooriDisableEnter]="true"></floori-icon>
        } @else {
        <floori-icon name="fl_eye_o" [flooriDisableEnter]="true"></floori-icon>
        }
    </button>
</div>
} @if (showStarInPlaceholder && value != null && value.length === 0) {
<div class="placeholder">
    <span class="name">{{ placeholder }}</span>
    <span class="star">*</span>
</div>
}

<ng-content select=".floori-input-appendix"></ng-content>
